import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    cardCustomPadding: {
      padding: '16px 20px 5px 32px',
    },

    cardContentPadding: {
      padding: '20px 32px 32px',
    },

    menuButton: {
      textTransform: 'capitalize',
      padding: 0,
    },

    statusIcon: {
      color: theme.palette.secondary.dark,
      marginLeft: 5,
    },

    prioritiesIcon: {
      color: theme.palette.secondary.light,
      marginLeft: 5,
    },

    textSecondary: {
      color: '#4D4F5C',
    },

    addButton: {
      fontSize: 13,
      padding: 0,
      marginRight: 15,
      textTransform: 'capitalize',
    },

    loadingContainer: {
      height: 150,
      width: '100%',
    },
    icon: {
      color: theme.palette.text.secondary,
      fontSize: theme.typography.pxToRem(19),
      marginRight: 11,
    },
    infoTitle: {
      minWidth: 90,
    },
    infoContent: {
      marginLeft: 16,
      width: '100%',
    },
    avatar: {
      fontSize: theme.typography.pxToRem(9),
      height: 22,
      marginRight: 8,
      width: 22,
    },
    avatarOwner: {
      backgroundColor: '#00C1BA',
    },
    avatarCreator: {
      backgroundColor: '#FFB027',
    },
  };
});

const customCardStyles = makeStyles((theme) => {
  return {
    root: {
      padding: 0,
      paddingBottom: '0 !important',
    },
  };
});

export { useStyles, customCardStyles };
